import API from "@aws-amplify/api";
import { useContext, useState } from "react";
import AppContext from "../contexts/AppContext";

const apiName = "redmineProxyApi";
const path = "/v1/redmine/proxy";
const term = 7; // 今日を起点として何日後を期日としたチケットを取得するか

export const useDueDateIssues = () => {
  const { state } = useContext(AppContext);
  const [allDueDateissues, setAllDueDateIssues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const getAllDueDateIssues = async () => {
    setLoading(true);
    setErrors({});
    getMultipleRedmineIssues()
      .then((res) => {
        let fulfilleds = [];
        let rejecteds = [];
        res.forEach((r) => {
          switch (r.status) {
            case "fulfilled":
              fulfilleds.push(r.value);
              break;
            case "rejected":
              const reason = r.reason.toJSON();
              const requestUrl = new URL(reason.config.url);
              const params = new URLSearchParams(requestUrl.search);
              const redmineUrl = params.get("url");
              rejecteds.push({
                message: reason.message,
                redmineUrl,
              });
              break;
            default:
          }
        });
        const sorted = fulfilleds.flat().sort(function (a, b) {
          return a.due_date > b.due_date ? 1 : -1;
        });
        setAllDueDateIssues(sorted);
        setErrors({ network: rejecteds });
      })
      .catch((error) => {
        setErrors({ internal: error });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getSingleRedmineIssues = async (props) => {
    const { apikey, redmineurl } = props;
    let query =
      "?assigned_to_id=me" +
      "&sort=due_date" +
      `&due_date=%3C%3D${formatDueDate()}`;
    const myInit = {
      // OPTIONAL
      headers: {
        "Content-type": "application/json",
        "X-Api-Key": apikey,
      }, // OPTIONAL
      queryStringParameters: {
        path: "issues.json" + query,
        url: redmineurl,
      },
    };
    const response = await API.get(apiName, path, myInit);
    return response;
  };

  const getMultipleRedmineIssues = async () => {
    const configs = state.siteConfigs;
    if (configs) {
      // 各Redmineから並列でissueを取得
      const multipleRedmineDueDateIssues = await Promise.allSettled(
        configs.map(async (config) => {
          const response = await getSingleRedmineIssues({
            apikey: config.apikey,
            redmineurl: config.redmineurl,
          });
          const issuesWithRedmineInfo = response.success.issues.map((issue) => {
            return {
              ...issue,
              redmine_id: config.id,
              redmine_name: config.name,
              redmineurl: config.redmineurl,
              apikey: config.apikey,
            };
          });
          return issuesWithRedmineInfo;
        })
      );
      return multipleRedmineDueDateIssues;
    }
  };

  const formatDueDate = () => {
    let termDate = new Date();
    termDate.setDate(termDate.getDate() + term);
    const year = termDate.getFullYear();
    const month = ("0" + (termDate.getMonth() + 1)).slice(-2);
    const date = ("0" + termDate.getDate()).slice(-2);
    const formatted_date = `${year}-${month}-${date}`;
    return formatted_date;
  };

  return {
    allDueDateissues,
    setAllDueDateIssues,
    loading,
    getAllDueDateIssues,
    errors,
  };
};
